<div class="trip-position">
    <div class="trip-position-icon" *ngIf="iconUrl">
        <img [src]="iconUrlSanitized">
    </div>
    <div class="trip-position-address">
        <ng-content select="app-trip-address-row"></ng-content>
    </div>
</div>
